import WahaInboxesAPI from '../../api/wahaInboxes';
import { throwErrorMessage } from '../utils/api';

export const state = {
  uiFlags: {
    isCreating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async create({ commit }, inboxData) {
    commit('setCreating', true);
    try {
      const response = await WahaInboxesAPI.create(inboxData);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit('setCreating', false);
    }
  },
};

export const mutations = {
  setCreating($state, value) {
    $state.uiFlags.isCreating = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
